import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ConsentBanner from "@/components/ConsentBanner";
import { initAnalytics } from "@/lib/analytics";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import CustomHomeBuilderTahlequah from "@/pages/CustomHomeBuilderTahlequah";
import ShopHouseBarndominium from "@/pages/ShopHouseBarndominium";
import HomeAdditions from "@/pages/HomeAdditions";
import HomeRemodeling from "@/pages/HomeRemodeling";
import Privacy from "@/pages/Privacy";

function App() {
    // Loads GA4 only if the visitor previously accepted analytics
    useEffect(() => {
        initAnalytics();
    }, []);

    return (
        <div className="App grain">
            <BrowserRouter>
                <ScrollToTop />
                <a href="#main-content" className="skip-to-content">
                    Skip to content
                </a>
                <Navbar />
                <main id="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route
                            path="/custom-home-builder-tahlequah-ok"
                            element={<CustomHomeBuilderTahlequah />}
                        />
                        <Route path="/custom-home-builder-tahlequah-ok" element={<CustomHomeBuilderTahlequah />} />
                        <Route path="/shop-house-barndominium-builder-tahlequah-ok" element={<ShopHouseBarndominium />} />
                        <Route path="/home-additions-tahlequah-ok" element={<HomeAdditions />} />
                        <Route path="/home-remodeling-tahlequah-ok" element={<HomeRemodeling />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <ConsentBanner />
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#151311",
                        color: "#F5F2EB",
                        border: "1px solid #2A2522",
                        borderRadius: "2px",
                    },
                }}
            />
        </div>
    );
}

export default App;
